export const PATH = {
  partnerDealsNew: '/partner_deals/new',
  partnerDeal: (skDealId: string) => `/partner_deals/${skDealId}`
} as const satisfies {
  [key in string]: string | ((...args: never[]) => string);
};

export const getSkFullPath = (path: string): string =>
  `${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_SK}${path}`;
